/* ===========================
   Garden Joy Spree — Theme JS v3
   =========================== */

(function() {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return (root || document).querySelectorAll(sel); }

  /* ========== Mobile Menu ========== */
  const mobileToggle = qs('.mobile-menu-toggle');
  const mobileNav = qs('.mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      const svg = mobileToggle.querySelector('svg');
      if (svg) {
        svg.innerHTML = isOpen
          ? '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>'
          : '<line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>';
      }
    });

    qsa('.mobile-nav__item[data-has-submenu]', mobileNav).forEach(btn => {
      btn.addEventListener('click', () => {
        const submenu = btn.nextElementSibling;
        if (!submenu) return;
        const isOpen = submenu.classList.toggle('is-open');
        const chevron = btn.querySelector('.chevron');
        if (chevron) chevron.style.transform = isOpen ? 'rotate(180deg)' : '';
        qsa('.mobile-nav__submenu.is-open', mobileNav).forEach(m => {
          if (m !== submenu) m.classList.remove('is-open');
        });
      });
    });
  }

  /* ========== Desktop Mega Menu — hover only, click navigates ========== */
  qsa('.main-nav li[data-has-submenu]').forEach(li => {
    const link = li.querySelector('.nav-link');
    const menu = li.querySelector('.mega-menu');
    if (!link || !menu) return;

    let timeout;
    const open = () => {
      clearTimeout(timeout);
      /* Close any other open menus */
      qsa('.main-nav .mega-menu.is-open').forEach(m => { if (m !== menu) m.classList.remove('is-open'); });
      menu.classList.add('is-open');
      link.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      timeout = setTimeout(() => {
        menu.classList.remove('is-open');
        link.setAttribute('aria-expanded', 'false');
      }, 200);
    };

    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', close);
    menu.addEventListener('mouseenter', () => clearTimeout(timeout));
    menu.addEventListener('mouseleave', close);

    /* Click on the link navigates (default <a> behavior — no preventDefault) */
    /* Keyboard: close on Escape */
    li.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); link.focus(); } });
  });

  /* ========== Cart Drawer ========== */
  const cartDrawer = qs('.cart-drawer');
  const cartOverlay = qs('.cart-overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.openCart = openCart;

  const cartToggle = qs('.cart-toggle');
  const cartClose = qs('.cart-drawer__close');
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  /* --- AJAX Cart helpers --- */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  function updateCartCount(count) {
    const badge = qs('.cart-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    } else if (count > 0) {
      const toggle = qs('.cart-toggle');
      if (toggle) {
        const span = document.createElement('span');
        span.className = 'cart-count';
        span.textContent = count;
        toggle.appendChild(span);
      }
    }
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newBody = doc.querySelector('.cart-drawer__body');
      const newFooter = doc.querySelector('.cart-drawer__footer');
      const oldBody = qs('.cart-drawer__body');
      const oldFooter = qs('.cart-drawer__footer');
      if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
      if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;
      else if (!newFooter && oldFooter) oldFooter.remove();
      else if (newFooter && !oldFooter && cartDrawer) cartDrawer.appendChild(newFooter);
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error('Cart refresh failed:', err);
      location.reload();
    }
  }

  document.addEventListener('click', async e => {
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (!qtyBtn) return;
    const line = parseInt(qtyBtn.dataset.line);
    const qty = parseInt(qtyBtn.dataset.cartQty);
    qtyBtn.disabled = true;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, qty) })
      });
      await refreshCartDrawer();
    } catch (err) { console.error('Cart update failed:', err); }
    finally { qtyBtn.disabled = false; }
  });

  document.addEventListener('click', async e => {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    const line = parseInt(removeBtn.dataset.line);
    removeBtn.disabled = true;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      });
      await refreshCartDrawer();
    } catch (err) { console.error('Cart remove failed:', err); }
  });

  /* --- Add to Cart (AJAX) --- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (res.ok) {
        const cart = await fetchCart();
        updateCartCount(cart.item_count);
        await refreshCartDrawer();
        openCart();
      } else {
        const data = await res.json();
        console.error('Add to cart error:', data);
      }
    } catch (err) { console.error('Add to cart failed:', err); }
    finally { if (btn) btn.disabled = false; }
  });

  /* ========== Product Page: Variant Selector ========== */
  qsa('.variant-btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', () => {
      const url = new URL(window.location);
      url.searchParams.set('variant', btn.dataset.variantId);
      window.location = url;
    });
  });

  /* ========== Quantity Selector ========== */
  qsa('[data-qty-selector]').forEach(selector => {
    const input = selector.querySelector('[data-qty-input]');
    const dec = selector.querySelector('[data-qty-decrease]');
    const inc = selector.querySelector('[data-qty-increase]');
    if (!input) return;

    const getVal = () => Math.max(1, parseInt(input.value, 10) || 1);

    if (dec) dec.addEventListener('click', () => {
      input.value = Math.max(1, getVal() - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (inc) inc.addEventListener('click', () => {
      input.value = getVal() + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('change', () => {
      if (getVal() < 1) input.value = 1;
    });
  });

  /* ========== Sticky ATC Bar ========== */
  const stickyAtc = qs('[data-sticky-atc]');
  const mainAtc = qs('.product-detail__atc');
  if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        /* Show sticky bar when main ATC is NOT visible */
        if (entry.isIntersecting) {
          stickyAtc.classList.remove('is-visible');
          stickyAtc.setAttribute('aria-hidden', 'true');
        } else {
          stickyAtc.classList.add('is-visible');
          stickyAtc.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
    observer.observe(mainAtc);
  }

  /* ========== Product Page: Read More Description ========== */
  qsa('[data-desc-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('[data-product-desc]');
      if (!wrapper) return;
      const expanded = wrapper.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });

  /* ========== Product Page: Image Gallery ========== */
  qsa('.product-detail__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = qs('.product-detail__gallery-main img');
      const fullUrl = thumb.getAttribute('data-full-image');
      const fullSrcset = thumb.getAttribute('data-full-srcset');
      const fullAlt = thumb.getAttribute('data-full-alt');
      if (main && fullUrl) {
        /* Clear srcset first to prevent browser from picking the old one */
        main.srcset = '';
        main.src = fullUrl;
        if (fullSrcset) main.srcset = fullSrcset;
        if (fullAlt) main.alt = fullAlt;
      }
      qsa('.product-detail__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ========== Filter Drawer (slide-in) ========== */
  const filterDrawer = qs('[data-filter-drawer]');
  const filterOverlay = qs('[data-filter-overlay]');

  function openFilters() {
    /* Skip on desktop — filters are shown as sidebar, no drawer needed */
    if (window.innerWidth >= 1024) return;
    if (filterDrawer) filterDrawer.classList.add('is-open');
    if (filterOverlay) filterOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
    if (filterOverlay) filterOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  qsa('[data-filter-open]').forEach(btn => btn.addEventListener('click', openFilters));
  qsa('[data-filter-close]').forEach(btn => btn.addEventListener('click', closeFilters));
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);

  /* ========== Inline Filter Pills: independent per-pill submit ========== */
  /*
   * Each pill (Serie, Pris, Tilgængelighed …) builds its own navigation URL
   * so changing one filter never affects the others. We start from the
   * current URL's search params and only touch the params that belong to
   * the pill the user interacted with.
   */

  function paramsForPill(pill) {
    /* Collect the param names owned by this pill's inputs */
    const names = new Set();
    pill.querySelectorAll('input[name]').forEach(input => names.add(input.name));
    return names;
  }

  function navigateWithPill(pill) {
    const url = new URL(window.location.href);

    /* 1. Clear out any existing values for the params this pill owns */
    paramsForPill(pill).forEach(name => url.searchParams.delete(name));

    /* 2. Add back the pill's current values (checkboxes, text inputs etc.) */
    pill.querySelectorAll('input[name]').forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) url.searchParams.append(input.name, input.value);
      } else if (input.value !== '' && input.value != null) {
        url.searchParams.append(input.name, input.value);
      }
    });

    /* Reset pagination so we don't land on an empty page */
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  const inlineFilters = qsa('[data-inline-filter]');
  const inlineForm = qs('[data-inline-filters]');

  /* Toggle dropdown on pill click */
  inlineFilters.forEach(wrapper => {
    const toggle = wrapper.querySelector('[data-inline-filter-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', e => {
      e.stopPropagation();
      const isOpen = wrapper.classList.contains('inline-filter--open');
      inlineFilters.forEach(w => w.classList.remove('inline-filter--open'));
      if (!isOpen) wrapper.classList.add('inline-filter--open');
    });
  });

  /* Close open dropdown when clicking outside */
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-inline-filter]')) {
      inlineFilters.forEach(w => w.classList.remove('inline-filter--open'));
    }
  });

  /* Close on Escape */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      inlineFilters.forEach(w => w.classList.remove('inline-filter--open'));
    }
  });

  /* Checkbox change → navigate only with that pill's params */
  inlineFilters.forEach(pill => {
    pill.addEventListener('change', e => {
      if (e.target.type === 'checkbox' || e.target.type === 'radio') {
        navigateWithPill(pill);
      }
    });
  });

  /* Apply button (price range, etc.) → navigate only with that pill's params */
  qsa('[data-inline-filter] [data-inline-filter-apply]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const pill = btn.closest('[data-inline-filter]');
      if (pill) navigateWithPill(pill);
    });
  });

  /* Prevent the outer <form> from submitting everything at once */
  if (inlineForm) {
    inlineForm.addEventListener('submit', e => e.preventDefault());
  }

  /* ========== Sort By ========== */
  const sortSelect = qs('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

})();
